import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import { Environment } from 'utils/deploymentInfo';
import fetchAPI from 'utils/http/fetchAPI';

// Disable unique keys to reallow reuse of work results in development
var DISABLE_UNIQUE_KEYS = ['GetEmbedding'];
var getCacheUniquenessKey = function getCacheUniquenessKey(taskName, environment) {
  // Disable cache in development or if localStorage says so
  // Do not disable for embeddings requests because download seurat & trajectory depend on that ETag
  if (environment !== Environment.PRODUCTION && localStorage.getItem('disableCache') === 'true' && !DISABLE_UNIQUE_KEYS.includes(taskName)) {
    return Math.random();
  }
  return null;
};
var checkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, body, requestProps, getState) {
    var environment, cacheUniquenessKey, request, _yield$fetchAPI, ETag, signedUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            environment = getState().networkResources.environment;
            cacheUniquenessKey = getCacheUniquenessKey(body.name, environment);
            request = {
              experimentId: experimentId,
              body: body,
              requestProps: _objectSpread(_objectSpread({}, requestProps), {}, {
                cacheUniquenessKey: cacheUniquenessKey
              })
            };
            _context.next = 5;
            return fetchAPI("/v2/workRequest/".concat(experimentId, "/check"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(request)
            });
          case 5:
            _yield$fetchAPI = _context.sent;
            ETag = _yield$fetchAPI.ETag;
            signedUrl = _yield$fetchAPI.signedUrl;
            return _context.abrupt("return", {
              ETag: ETag,
              signedUrl: signedUrl
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function checkRequest(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default checkRequest;